export default __webpack_public_path__ + "static/media/m_two.d6014f86.png";